// Note:
// _menu: nếu là các menu
// _act: nếu là các action của button, ...

export const GlobalPolcies = {
  capPhatDongPhucModule: {
    left_menu: {
      cap_phat_dong_phuc: '1617', //web: menu left - Cấp phát đồng phục
      trang_chu: '1607', //web: menu left - Cấp phát đồng phục - Trang chủ
      phat_dong_phuc: '1608', //web: menu left - Cấp phát đồng phục - Phát động phục
      du_lieu_dau_ky: '1609', //web: menu left - Cấp phát đồng phục - Dữ liệu đầu kỳ
      xu_ly_trong_ngay: '1610', //web: menu left - Cấp phát đồng phục - Xử lý trong ngày
      xu_ly_trong_ngay_menu: {
        nhap_trong_ngay: '1611', //web: menu left - Cấp phát đồng phục - Xử lý trong ngày - Nhập trong ngày
        tong_hop_trong_ngay: '1612', //web: menu left - Cấp phát đồng phục - Xử lý trong ngày - Tổng hợp trong ngày
        doi_tra: '1613' //web: menu left - Cấp phát đồng phục - Xử lý trong ngày - Đổi trả
      },
      thong_ke_bao_cao: '1614', //web: menu left - Cấp phát đồng phục - Thống kê báo cáo
      thong_ke_bao_cao_menu: {
        bao_cao_tong_hop: '1623', //web: menu left - Cấp phát đồng phục - Thống kê báo cáo - Tổng hợp
        bao_cao_cap_phat: '1624', //web: menu left - Cấp phát đồng phục - Thống kê báo cáo - Cấp phát
        /**
         * B17 — mục 8 "Xuất thống kê".
         *
         * DÙNG LẠI mã quyền của **menu 4 "Xử lý trong ngày"** (`xu_ly_trong_ngay_menu.nhap_trong_ngay`)
         * thay vì xin mã mới từ IAM → menu hiện được ngay, không chặn deploy. Ai đang vào được
         * màn xử lý trong ngày thì cũng thấy mục 8.
         *
         * ⚠️ Hệ quả: KHÔNG bật/tắt riêng mục 8 được — gỡ quyền mục 8 là gỡ luôn menu 4.
         * Khi IAM cấp mã riêng, đổi đúng 1 dòng ở đây.
         *
         * ⚠️ `xu_ly_trong_ngay: '1610'` ở trên trông có vẻ hợp lý hơn về tên nhưng KHÔNG dùng nó:
         * mã đó được khai báo mà không gắn vào menu nào, nên nhiều khả năng chưa gán cho tài khoản
         * nào trong IAM → dùng vào là menu vẫn ẩn.
         */
        xuat_thong_ke: '1611' //web: menu left - Cấp phát đồng phục - Thống kê báo cáo - Xuất thống kê (mượn mã menu 4)
      },
      du_lieu_ke_hoach: '1615', //web: menu left - Cấp phát đồng phục - Dữ liệu kế hoạch
      logs: '1616', //web: menu left - Cấp phát đồng phục - Logs
    },
    actions: {
      cap_phat_dong_phuc: {
        chi_tiet: {
          nghiep_vu: {
            cap_phat_tab_act: '1618', //web: Feature - Cấp phát đồng phục - Chi tiết - Nghiệp vụ - Cấp phát tab
            doi_tra_tab_act: '1620', //web: Feature - Cấp phát đồng phục - Chi tiết - Nghiệp vụ - Đổi trả tab
          },
          danh_sach_phieu_thu: {
            chinh_sua_phieu_thu_act: '1619', //web: Feature - Cấp phát đồng phục - Chi tiết - Danh sách phiếu thu - Chỉnh sửa
            huy_phieu_thu_act: '1621', //web: Feature - Cấp phát đồng phục - Chi tiết - Danh sách phiếu thu - Hủy phiếu thu
          },
        },
      },
      logs: {
        xem_chi_tiet_btn_act: '1622', //web: Feature - Cấp phát đồng phục - Logs - Xem chi tiết button
      }
    },
  }
};
